import clsx from 'clsx';
import styles from './ProgressBar.module.css';

export interface ProgressBarProps {
  /** 0..1; `null` = indeterminate. */
  value: number | null;
  /** Accessible label (e.g. "Upload progress"). */
  label: string;
  tone?: 'accent' | 'success' | 'warning' | 'danger';
  size?: 'sm' | 'md';
  className?: string;
}

export function ProgressBar({ value, label, tone = 'accent', size = 'md', className }: ProgressBarProps) {
  const pct = value === null ? null : Math.round(Math.min(1, Math.max(0, value)) * 100);
  return (
    <div
      role="progressbar"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={pct ?? undefined}
      className={clsx(
        styles.track,
        styles[size],
        styles[tone],
        pct === null && styles.indeterminate,
        className,
      )}
    >
      <div className={styles.bar} style={pct === null ? undefined : { width: `${pct}%` }} />
    </div>
  );
}
